import request from '@/request/request'

/**
 * 地理编码查询
 * @returns 
 */
export function geocoder (parameter) {
  return request({
    url: '/external-service-center/tdtMap/geocoder',
    method: 'get',
    params: parameter
  })
}

/**
 * 逆地理编码查询
 * @returns 
 */
export function reverseGeocoder (parameter) {
  return request({
    url: '/external-service-center/tdtMap/reverseGeocoder',
    method: 'get',
    params: parameter
  })
}

